import { GraphQLClient } from 'graphql-request'

import GetSurveyPublicDetailsGQL from '@/vuex/graphql/queries/getSurveyPublicDetails.query.gql'
import GetConsumerFavoriteUnitGQL from '@/vuex/graphql/queries/getConsumerFavoriteUnit.query.gql'
import AuthenticateUserFromSurveyGQL from '@/vuex/graphql/mutations/authenticateUserFromSurvey.mutation.gql'
import ListQuestionsBySurveyGQL from '@/vuex/graphql/queries/listQuestionsBySurvey.query.gql'
import AnswerQuestionsGQL from '@/vuex/graphql/mutations/answerQuestions.mutation.gql'

const apolloFederationUrl = process.env.VUE_APP_APOLLO_FEDERATION_URL

export class SurveyService {
  constructor(accountId, token) {
    this.graphqlClient = new GraphQLClient(apolloFederationUrl)
    if (accountId) {
      this.graphqlClient.setHeader('accountid', accountId)
    }
    if (token) {
      this.graphqlClient.setHeader('authorization', `Bearer ${token}`)
    }
  }

  async authenticateUserFromSurvey(surveyId, userId, turnstileCode) {
    const response = await this.graphqlClient.request(AuthenticateUserFromSurveyGQL, {
      surveyId,
      userId,
      turnstileCode
    })
    return response?.authenticateUserFromSurvey
  }

  async authenticateUserFromShortCode(shortCode, turnstileCode) {
    const response = await this.graphqlClient.request(AuthenticateUserFromSurveyGQL, {
      shortCode,
      turnstileCode
    })
    return response?.authenticateUserFromSurvey
  }

  async fetchPublicDetails(surveyId) {
    const response = await this.graphqlClient.request(GetSurveyPublicDetailsGQL, {
      surveyId
    })
    return response?.getSurveyPublicDetails
  }

  async fetchConsumerFavoriteUnit(surveyId, userId) {
    const response = await this.graphqlClient.request(GetConsumerFavoriteUnitGQL, {
      surveyId,
      userId
    })
    const favoriteUnitId = response?.getConsumerFavoriteUnit?.favoriteUnitId
    return favoriteUnitId != null ? favoriteUnitId : null
  }

  async fetchQuestions(surveyId) {
    const response = await this.graphqlClient.request(ListQuestionsBySurveyGQL, {
      surveyId
    })
    return response?.listQuestionsBySurvey?.questions
  }

  async answerQuestions(input) {
    const response = await this.graphqlClient.request(AnswerQuestionsGQL, {
      input
    })
    return response?.answerQuestions
  }
}
